(function ($, psw, window) {
    'use strict';

    $(function() {
        $("#sbp-contact-form").submit( function(e){
            e.preventDefault();

            var frm = $('#sbp-contact-form');

            if (!frm.valid())
            {
                return false;
            }

            var postData = {
                FirstName: $("#first-name").val(),
                LastName: $("#last-name").val(),
                Company: $("#company").val(),
                Email: $("#email-address").val(),
                Title: "Small Business Program Contact Us",
                Context: $("#message").val()
            };

            // Execute Turnstile and submit form
            psw.executeTurnstile(function (token) {
                postData.turnstileToken = token;
                $.ajax({
                    url: psw.api('/contactus'),
                    type: 'POST',
                    data: postData,
                    headers: {'X-Alt-Referer': location.href },
                    complete: function (xhr, textStatus) {
                        if (textStatus == "success") {
                            window.scrollTo(0, 0);
                            $('#display-main').hide();
                            $('#display-thankyou').show();
                            GA4Event.contactUsSubmit(contactUsPosition.inPage);
                        }
                        else {
                            psw.alerts.error('Something went wrong and we could not send your request. Sorry for the extra work. Please send us an old-fashioned email at <a href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#115;&#117;&#112;&#112;&#111;&#114;&#116;&#64;&#112;&#97;&#114;&#116;&#105;&#99;&#117;&#108;&#97;&#114;&#46;&#110;&#101;&#116;">&#115;&#117;&#112;&#112;&#111;&#114;&#116;&#64;&#112;&#97;&#114;&#116;&#105;&#99;&#117;&#108;&#97;&#114;&#46;&#110;&#101;&#116;</a>.', false);
                            GA4Event.contactUsFail(contactUsPosition.inPage);
                        }
                    }
                });
            });
            return false;
        });
    });

}(jQuery, psw, window));
